import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectHeaderInfo } from '../../state/patient.selectors';
import { WINDOW } from 'Shared/app/core/services/window.service';
import { WFP_ROUTES } from 'projects/patient/src/app/constants/routes';

@Component({
  selector: 'wfp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  readonly #store = inject(Store);
  readonly #router = inject(Router);
  readonly #WINDOW = inject<Window>(WINDOW);

  protected headerInfo$ = this.#store.select(selectHeaderInfo);

  logout(): void {
    this.#router.navigateByUrl(WFP_ROUTES.LOGOUT, { skipLocationChange: true });
  }

  returnToExternalSite(url: string): void {
    setTimeout(() => {
      this.#WINDOW.location.href = url;
    }, 50);
  }
}
